import { CartItemAssociationService } from '../../../data/services'
import { CartItemAssociation } from '../../../data/models'
import { IDataServiceConfig, ModelRepository } from '../../../model-repository'

export const CartItemAssociationConfig: IDataServiceConfig<CartItemAssociation> = {
  service: CartItemAssociationService,
  deps: [ModelRepository],
  endpoint: 'orders/cart_item_associations?filter[user-id]=:user_id',
  model: CartItemAssociation,
  presenter: null,
  backend: 'uncached',
  mappings: [{
    classType: 'CartItemAssociation',
    jsonType: 'cart-item-associations',
    propertyMapping: {
      purchasedProduct: { type: 'Product' },
      purchasedCartItem: { type: 'CartItem', },
      associatedCartItem: { type: 'CartItem' }
    }
  }]
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/data/cart-item-association.config.ts